import { render } from "./CreateRetailerInvite.vue?vue&type=template&id=68f83e9b&scoped=true"
import script from "./CreateRetailerInvite.vue?vue&type=script&lang=js"
export * from "./CreateRetailerInvite.vue?vue&type=script&lang=js"

import "./CreateRetailerInvite.vue?vue&type=style&index=0&id=68f83e9b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f83e9b"]])

export default __exports__